<template>
  <div class="campaign-points-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header
      :title="[campaign.name, 'Pontos', pointId ? 'Editar' : 'Cadastrar']"
      :loading="loading"
    >
      <button
        v-app-button.icon-left.clear
        v-app-back-button="`/campaign/${campaignId}/points/`"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <campaign-points-form
        @submit="onSubmit"
        :id="pointId"
        :errors="errors"
        :saving="isSaving"
      ></campaign-points-form>
    </app-card>
  </div>
</template>

<script>
import CampaignService from '@/services/campaign.service';
import CampaignPointsForm from '@/components/Forms/CampaignPointsForm.vue';
import CampaignPointsService from '@/services/campaign-points.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'campaign-points-form-page',
  mixins: [ToastMixin],
  components: {
    CampaignPointsForm,
  },
  data: () => {
    return {
      pointId: null,
      campaignId: null,
      campaign: {},
      errors: {},
      loading: true,
      isSaving: false,
    };
  },
  methods: {
    onSubmit(point) {
      this.errors = {};
      !this.pointId && this.save({ ...point, campaign_id: this.campaignId });
      this.pointId && this.update({ ...point, campaign_id: this.campaignId });
    },
    loadCampaign(id) {
      CampaignService.getId(id)
        .then(({ data: campaign }) => (this.campaign = campaign))
        .finally(() => (this.loading = false));
    },
    save(point) {
      this.isSaving = true;
      CampaignPointsService.save(point)
        .then(() => {
          this.toastify('Ponto cadastrado com sucesso!');
          this.$router.push(`/campaign/${this.campaignId}/points/`);
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Ponto.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(point) {
      this.isSaving = true;
      CampaignPointsService.update(this.pointId, point)
        .then(() => {
          this.toastify('Ponto atualizado com sucesso!');
          this.$router.push(`/campaign/${this.campaignId}/points/`);
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Ponto.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.pointId = this.$route.params.id;
    this.campaignId = this.$route.params.campaignId;
    this.campaignId && this.loadCampaign(this.campaignId);
  },
};
</script>
